// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1s4mT","label":"Section_label__2ZqK-","contentWrap":"Section_contentWrap__2PKSA","footer":"Section_footer__3JMVX","footerInner":"Section_footerInner__2HOrf"};